import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Code,
	Text,
	useDisclosure,
	useToast,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { HAR_GITS_RECALLS_KEY, usePerformRecallMutation } from '../../../../state/server-side/queries/carolive-v3';
import { useQueryClient } from 'react-query';

/**
 * @param {object} props
 * @param {import('./info').GitsHarRecall} props.recall
 * @param {string} props.orderId
 */
export const PerformRecall = ({ recall, orderId }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const cancelRef = useRef();
	const toast = useToast();
	const queryClient = useQueryClient();
	const mutation = usePerformRecallMutation();

	const handleSubmit = () => {
		mutation.mutate(
			{ id: recall.id, orderId },
			{
				onSuccess: () => {
					queryClient.invalidateQueries([HAR_GITS_RECALLS_KEY, recall.vin]);
					onClose();
				},
				onError: error => {
					const errorMessage = error?.cause?.map(e => e.message).join('\n');
					toast({
						title: 'Eroare!',
						description: errorMessage,
						status: 'error',
						duration: 5000,
						isClosable: true,
					});
				},
			}
		);
	};

	return (
		<>
			<Button type="button" onClick={onOpen}>
				Marcheaza ca efectuat
			</Button>

			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onClose}
				closeOnEsc={false}
				closeOnOverlayClick={false}
				isCentered={true}
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							Marcheaza ca efectuat
						</AlertDialogHeader>

						<AlertDialogBody display={'flex'} flexDirection={'column'} gap={2}>
							<Text>
								Confirm ca am efectuat campania <Code>{recall.denumire}</Code>.
							</Text>
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onClose} isDisabled={mutation.isLoading}>
								Renunta
							</Button>
							<Button colorScheme="blue" onClick={handleSubmit} isLoading={mutation.isLoading} ml={3}>
								Confirma
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
};
